import React from 'react';
import { Col, FormGroup, Input, InputGroup, Label } from 'reactstrap';
import { T } from '../helpers/i18n';
export var LabelInput = function (props) {
    var name = props.name, value = props.value, onChange = props.onChange;
    return (React.createElement("div", null,
        React.createElement(RFormGroup, { placeholder: T(name), name: name, value: value, onChange: onChange })));
};
export var RFormGroup = function (props) {
    return (React.createElement(FormGroup, { row: true },
        React.createElement(Label, { for: props.name, md: 5, sm: 12 }, props.name),
        React.createElement(Col, { md: 7, sm: 12 },
            React.createElement(InputGroup, null,
                React.createElement(Input, { placeholder: props.placeholder, name: props.name, type: 'text', value: props.value, onChange: props.onChange })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/LabelInput.tsx
// module id = 1518
// module chunks = 0